<template>
  <clinic-layout title="Add appointment" :subtitle="subtitle">
    <div v-if="!doctor.doctorId" class="adm-alert adm-alert--warning">
      <i class="fas fa-exclamation-triangle"></i>
      <div>
        Choose a doctor first.
        <router-link to="/clinic-dashboard" class="add-appt__link">Go to doctors</router-link>
      </div>
    </div>

    <template v-else>
      <ol class="add-appt__steps" aria-label="Steps">
        <li class="is-current"><span>1</span> Find the patient</li>
        <li><span>2</span> Pick date &amp; time</li>
      </ol>
      <patient-finder @book="book" />
    </template>
  </clinic-layout>
</template>

<script>
import ClinicLayout from "./components/ClinicLayout.vue";
import PatientFinder from "./components/PatientFinder.vue";

export default {
  name: "add-clinic-appointment",
  components: { ClinicLayout, PatientFinder },
  computed: {
    doctor() {
      return this.$store.getters.getclinicDetails || {};
    },
    subtitle() {
      if (!this.doctor.doctorId) return "Find or register the patient, then pick a slot.";
      const who = this.doctor.doctorName ? `Dr. ${this.doctor.doctorName}` : "the selected doctor";
      return this.doctor.clinicname ? `For ${who} at ${this.doctor.clinicname}` : `For ${who}`;
    },
  },
  methods: {
    book(patientid) {
      this.$store.dispatch("updateAppointmentDraft", {
        patientid,
        doctorid: this.doctor.doctorId,
        doctorImage: this.doctor.doctorImage,
      });
      this.$router.push({ path: `/bookingclinic/${this.doctor.doctorId}`, query: { from: "ClinicDashboard" } });
    },
  },
};
</script>

<style scoped>
.add-appt__steps {
  display: flex;
  gap: 24px;
  list-style: none;
  padding: 0;
  margin: 0 0 16px;
  font-size: 13px;
  font-weight: 600;
  color: var(--adm-muted);
}

.add-appt__steps li {
  display: flex;
  align-items: center;
  gap: 8px;
}

.add-appt__steps span {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  background: var(--adm-line);
  color: var(--adm-ink-2);
}

.add-appt__steps .is-current {
  color: var(--adm-ink);
}

.add-appt__steps .is-current span {
  background: var(--adm-primary);
  color: #fff;
}

.add-appt__link {
  font-weight: 700;
  color: inherit;
  text-decoration: underline;
  margin-left: 4px;
}
</style>
